import type {LinkedPullRequest} from '../../../api/common-contracts'
import {LinkedPullRequestToken} from '../../fields/linked-pr-token'
import {BaseCell} from './base-cell'
import styles from './linked-pull-requests-group.module.css'

interface LinkedPullRequestGroupProps {
  linkedPullRequests: Array<LinkedPullRequest> | undefined
  isDecorative?: boolean
}

export const LinkedPullRequestGroup: React.FC<LinkedPullRequestGroupProps> = ({linkedPullRequests, isDecorative}) => {
  return (
    <BaseCell className={styles.BaseCell}>
      {linkedPullRequests?.map(linkedPullRequest => (
        <LinkedPullRequestToken
          linkedPullRequest={linkedPullRequest}
          tabIndex={-1}
          key={linkedPullRequest.id}
          isDecorative={isDecorative}
        />
      ))}
    </BaseCell>
  )
}

try{ LinkedPullRequestGroup.displayName ||= 'LinkedPullRequestGroup' } catch {}